import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import { getErrorLogs } from "../../../../api/errorLog";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { alertError } from "../../../../utils/logger";
import FiltersCard from "../../../components/filters/Filter";

const PROCESS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "tarificacion", label: "Tarificación" },
  { value: "generar_oferta", label: "Generar oferta" },
  { value: "api", label: "API" },
];

const initialFilters = { dateFrom: "", dateTo: "", process: "" };

function truncate(str, max = 60) {
  if (!str) return "—";
  const s = String(str);
  return s.length > max ? s.substring(0, max) + "…" : s;
}

export default function LogsPage() {
  const [data, setData] = useState([]);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [detailLog, setDetailLog] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);

  const loadLogs = () => {
    setLoading(true);
    const params = {};
    if (filterOptions.dateFrom) params.dateFrom = filterOptions.dateFrom;
    if (filterOptions.dateTo) params.dateTo = filterOptions.dateTo;
    if (filterOptions.process) params.process = filterOptions.process;
    getErrorLogs(params)
      .then((res) => {
        if (res.status === 200)
          setData(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        alertError({
          error: err,
          customMessage: "No se han podido cargar los logs de errores.",
        });
        setData([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadLogs();
  }, []);

  const handleSearch = () => {
    loadLogs();
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    loadLogs();
  };

  const openDetail = (row) => {
    setDetailLog(row);
    setDetailOpen(true);
  };

  const columns = [
    {
      dataField: "createdAt",
      text: "Fecha y hora",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "process", text: "Proceso", sort: true },
    { dataField: "step", text: "Paso", sort: true },
    {
      dataField: "message",
      text: "Mensaje",
      formatter: (cell) => truncate(cell),
      sort: true,
    },
    {
      dataField: "peticionId",
      text: "Petición",
      formatter: (cell) => (cell ? String(cell) : "—"),
      sort: true,
    },
    {
      dataField: "_id",
      text: "",
      formatter: (cell, row) => (
        <Button
          style={buttonsStyle}
          size="small"
          onClick={() => openDetail(row)}
          title="Ver detalle"
        >
          <Visibility />
        </Button>
      ),
      headerStyle: () => ({ width: "80px", textAlign: "center" }),
    },
  ];

  const tableData = data.map((item) => ({
    ...item,
    id: item._id,
  }));

  const renderFiltersContent = () => (
    <>
      <div className="d-flex align-items-center flex-wrap">
        <div className="col-md-3 mt-2">
          <TextField
            type="date"
            label="Desde"
            value={filterOptions.dateFrom || ""}
            onChange={(e) =>
              setFilterOptions({ ...filterOptions, dateFrom: e.target.value })
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
            variant="outlined"
            size="small"
          />
        </div>
        <div className="col-md-3 mt-2">
          <TextField
            type="date"
            label="Hasta"
            value={filterOptions.dateTo || ""}
            onChange={(e) =>
              setFilterOptions({ ...filterOptions, dateTo: e.target.value })
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
            variant="outlined"
            size="small"
          />
        </div>
        <div className="col-md-3 mt-2">
          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel id="log-process-label">Proceso</InputLabel>
            <Select
              labelId="log-process-label"
              value={filterOptions.process || ""}
              onChange={(e) =>
                setFilterOptions({ ...filterOptions, process: e.target.value })
              }
              label="Proceso"
            >
              {PROCESS_OPTIONS.map((opt) => (
                <MenuItem key={opt.value || "all"} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      <br />
    </>
  );

  return (
    <>
      <Card>
        <CardHeader title="Logs de errores" />
        <CardBody>
          <FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />
          {loading ? (
            <p>Cargando…</p>
          ) : (
            <Table
              data={tableData}
              columns={columns}
              keyField="id"
              noSearch={false}
              defaultSorted={[{ dataField: "createdAt", order: "desc" }]}
            />
          )}
        </CardBody>
      </Card>

      <Dialog
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        maxWidth="md"
        fullWidth
        aria-labelledby="detail-error-dialog"
      >
        <DialogTitle id="detail-error-dialog">
          Detalle del error{" "}
          {detailLog?.createdAt
            ? `(${new Date(detailLog.createdAt).toLocaleString()})`
            : ""}
        </DialogTitle>
        <DialogContent dividers>
          {detailLog && (
            <>
              <p>
                <strong>Proceso:</strong> {detailLog.process}
              </p>
              <p>
                <strong>Paso:</strong> {detailLog.step}
              </p>
              {detailLog.peticionId && (
                <p>
                  <strong>Petición:</strong> {String(detailLog.peticionId)}
                </p>
              )}
              <p>
                <strong>Mensaje:</strong>
              </p>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  background: "#f5f5f5",
                  padding: 12,
                  borderRadius: 4,
                }}
              >
                {detailLog.message || "—"}
              </pre>
              {detailLog.stack && (
                <>
                  <p>
                    <strong>Stack trace (archivo y línea):</strong>
                  </p>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      background: "#f5f5f5",
                      padding: 12,
                      borderRadius: 4,
                      fontSize: 12,
                    }}
                  >
                    {detailLog.stack}
                  </pre>
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDetailOpen(false)}
            color="primary"
            variant="contained"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
